// extracted by mini-css-extract-plugin
module.exports = {"SmartInvestForm":"SmartInvestForm-module__SmartInvestForm___3T-Q9"};